import * as React from "react";

export const AuditLog = (props: { className?: string; color: string }): JSX.Element => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.className}
    >
        <path
            d="M8 9.75C7.58579 9.75 7.25 9.41421 7.25 9C7.25 8.58579 7.58579 8.25 8 8.25L16 8.25C16.4142 8.25 16.75 8.58579 16.75 9C16.75 9.41421 16.4142 9.75 16 9.75L8 9.75ZM8 13.25C7.58579 13.25 7.25 12.9142 7.25 12.5C7.25 12.0858 7.58579 11.75 8 11.75L16 11.75C16.4142 11.75 16.75 12.0858 16.75 12.5C16.75 12.9142 16.4142 13.25 16 13.25L8 13.25ZM8 16.75C7.58579 16.75 7.25 16.4142 7.25 16C7.25 15.5858 7.58579 15.25 8 15.25L11.4287 15.25C11.8429 15.2501 12.1787 15.5858 12.1787 16C12.1787 16.4142 11.8429 16.7499 11.4287 16.75L8 16.75Z"
            fill={props.color}
        />
        <path
            d="M18.75 7C18.75 6.30964 18.1904 5.75 17.5 5.75H6.5C5.80964 5.75 5.25 6.30964 5.25 7V18C5.25 18.6904 5.80964 19.25 6.5 19.25H17.5C18.1904 19.25 18.75 18.6904 18.75 18V7ZM20.25 18C20.25 19.5188 19.0188 20.75 17.5 20.75H6.5C4.98122 20.75 3.75 19.5188 3.75 18V7C3.75 5.48122 4.98122 4.25 6.5 4.25H17.5C19.0188 4.25 20.25 5.48122 20.25 7V18Z"
            fill={props.color}
        />
    </svg>
);
